module.exports = __webpack_public_path__ + "img/cat-emoji.66fde03f.svg";